import {Fragment} from "react/jsx-runtime";
import {AutoScrollTop, ReduxNavigation} from "components";

interface HelpersProps {}

export const Helpers: React.FC<HelpersProps> = () => {
  return (
    <Fragment>
      <AutoScrollTop />
      <ReduxNavigation />
    </Fragment>
  );
};
